import { ChangeDetectionStrategy, Component, computed, forwardRef, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';

import { DocumentActionsComponent } from '@module-definition/document/document-actions/document-actions.component';
import { CipoStateComponent } from '@shared/components/cipo-state/state.component';
import { APPROVAL_COLOR } from '@shared/consts';
import { DialogFullscreenState } from '@shared/dialogs/full-screen-dialog.base';
import { CipoDialogModule } from '@shared/modules';
import { UserStore } from '@signal-store/index';

import { DocumentDetailsDialogData, DocumentDetailsStore } from '../common';
import { DocumentDetailsComponent } from '../document-details.component';

/** Dialog chrome only. Anything functional belongs in `DocumentDetailsComponent`, which has no dialog
 * dependency so it can also be hosted outside a dialog. */
@Component({
  selector: 'cipo-document-details-dialog',
  templateUrl: './document-details-dialog.component.html',
  imports: [
    CipoDialogModule,
    MatMenuModule,
    CipoStateComponent,
    DocumentActionsComponent,
    forwardRef(() => DocumentDetailsComponent),
  ],
  /* one store per dialog, so a nested dialog cannot see this one's documents or transitions */
  providers: [DocumentDetailsStore],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentDetailsDialogComponent {
  private readonly userStore = inject(UserStore);

  readonly data = inject<DocumentDetailsDialogData>(MAT_DIALOG_DATA);
  readonly dialogRef = inject(MatDialogRef<DocumentDetailsDialogComponent>);
  readonly fullscreen = new DialogFullscreenState(this.dialogRef);
  readonly APPROVAL_COLOR = APPROVAL_COLOR;

  readonly currentModule = computed(() =>
    this.userStore.menuItemsList().find(mi => mi.moduleId === this.data.moduleId),
  );
}
